import 'jquery-match-height';
import 'bootstrap';
import 'slick-carousel';

import { Fancybox } from '@fancyapps/ui/dist/fancybox';

import TestimonialsSlider from './modules/testimonials-slider';
import VideoAndButtons from './modules/VideoAndButtons';
import LangDropdown from './utilities/lang-dropdown';
import SmoothScroll from './utilities/smooth-scroll';
import ready, { HTML } from './utilities/utilities';
import Vimeo from './utilities/vimeo';
import CF7 from './components/cf7';
import Nav from './components/nav';
import CarouselModule from './modules/carousel';
import SixGrid from './modules/6-grid';

ready(() => {
    LangDropdown.init();
    Vimeo.init();
    TestimonialsSlider.init();
    VideoAndButtons.init();
    SmoothScroll.init();
    CF7.init();
    Nav.init();
    CarouselModule.init();
    SixGrid.init();

    Fancybox.bind('[data-fancybox]', {
    });
});